<template>
    <sweet-modal icon="warning" ref="deleteVideoModal" @close="$emit('modal-close')">
        <div v-if="selected !== null" class="text-center">
            <p class="mt-3" v-html="$t('pages.admin.video.index.delete_confirmation', {title: selected.title[$i18n.locale]})"></p>

            <delete-confirmation @clicked="deleteSelected">
                {{ $t('actions.delete') }}
            </delete-confirmation>
        </div>
    </sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
import AdminVideoRepository from "../../../repositories/Admin/AdminVideoRepository";
import DeleteConfirmation from "../../Includes/DeleteConfirmation";
export default {
    name: "VideoDeleteModal",
    components: {DeleteConfirmation, SweetModal},
    props: {
        selected: {
            type: Object,
            default: null
        }
    },
    methods: {
        deleteSelected() {
            AdminVideoRepository
                .deleteVideo(this.selected.id)
                .then((res) => {
                    this.$emit('video-deleted');
                    this.$refs.deleteVideoModal.close();
                });
        }
    },
    watch: {
        selected: function (val) {
            if(val !== null)
                this.$refs.deleteVideoModal.open();
        }
    }
}
</script>

<style scoped>

</style>
